import styled from "@emotion/styled";

export const ContentWrapper = styled.div`
  text-align: center;
  display: block;
  button {
    display: block;
    margin: 0 auto;
    margin-top: 30px;
  }
`;
